<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>礼包管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏扶持发放</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
      <el-input v-model="queryField.userId" size="small" placeholder="玩家id"></el-input>
      <el-input v-model="queryField.userName" size="small" placeholder="玩家账号"></el-input>
      <el-input v-model="queryField.serverCode" size="small" placeholder="区服"></el-input>
      <el-input v-model="queryField.serverName" size="small" placeholder="区服名称"></el-input>
      <el-input v-model="queryField.roleName" size="small" placeholder="角色名称"></el-input>
      <el-button  type="primary" icon="el-icon-search" size="small" @click="loadData(1)">查询</el-button>
    </el-row>
    <el-table class="cps-table-data"
              v-loading="loading"
              :data="tableData" size="small"
              border
              :height="height"
              style="width: 100%">
      <!--<el-table-column
          prop="game_id"
          label="游戏ID"
          width="80">
      </el-table-column>-->
      <el-table-column
          prop="game_name"
          label="游戏名称"
          width="120">
      </el-table-column>

      <el-table-column
              prop="role_name"
              label="角色名字"
              width="150">
      </el-table-column>

      <el-table-column
          prop="user_id"
          label="账号id"
          width="80">
      </el-table-column>
      <el-table-column
          prop="user_name"
          label="玩家账号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="admin_name"
          label="归属渠道"
          width="120">
      </el-table-column>
      <el-table-column
          prop="server_code"
          label="区服"
          width="120">
      </el-table-column>
      <el-table-column
          prop="server_name"
          label="区服名称"
          width="140">
      </el-table-column>
      <el-table-column
          prop="role_code"
          label="角色id"
          width="100">
      </el-table-column>
      <el-table-column
              prop="ip_address"
              label="所在地"
              width="110">
      </el-table-column>
      <el-table-column
              label="操作">
        <template slot-scope="scope">
          <el-button
                  v-if="showSend"
                  type="text"
                  size="small"
                  @click="openItemPage(scope.row)">发放扶持</el-button>

          <el-button
                  v-if="showSend"
                  type="text"
                  size="small"
                  @click="updateIp(scope.row.user_id)">修改所在地</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination  class="cps-table-data"
        @current-change="loadData"
        background
        :page-size="15"
        layout="total, prev, pager, next"
        :total="total">
    </el-pagination>
    </div>

    <el-drawer
            :visible.sync="showItemList"
            direction="rtl"
            size="650px">
      <el-table :data="itemData" class="drawer-table-data" border >
        <el-table-column property="id" label="ID" width="80"></el-table-column>
        <el-table-column property="recharge_point" label="物品名称" width="160"></el-table-column>
        <el-table-column property="price" label="价值" width="160"></el-table-column>
        <el-table-column label="操作"  width="200">
          <template slot-scope="scope">
            <el-button type="text"  size="small" @click="doSend(scope.row)">确认发放</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

  </div>
</template>
<script>
import {getSupportRoleList, getPageButtons, getSupportItem, supportSubmit, updateIp} from "@/api/request";
export default {
  name: 'gameRole',
  data() {
    return {
      tableData: [],
      queryField: {
        roleCode:'',
        roleName:'',
        serverCode:'',
        serverName:'',
        gameId: '',
        gameName: '',
        userId: '',
        userName: '',
      },
      total: 0,
      height: window.innerHeight - 210,
      showSend: false,
      showItemList: false,
      itemData: [],
      selectedUser: {},
      loading: false,
      currentIndex: 1,
    };
  },
  mounted() {
    this.loadData(1);
    this.getPageButtons();
  },
  methods: {
    updateIp(user_id) {
      this.$prompt("", "修改角色所在地", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
      .then(({ value }) => {
        let params = {
          user_id: user_id,
          ip: value,
        };
        updateIp(params).then((res) => {
          if (res.data.success) {
            this.$message.success("修改成功");
            this.loadData(this.currentIndex)
          } else {
            this.$message.error(res.data.error.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消修改",
        });
      });
    },
    openItemPage(row) {
      this.selectedUser = row;
      let params = {
        pageNo: 1,
        pageSize: 9999,
      }
      getSupportItem(params).then(res => {
        this.showItemList = true;
        this.itemData = res.data.list;
      });
    },
    doSend(item) {
      let user = this.selectedUser;
      let msg = `确认发放价值为${item.price}的扶持物品【${item.recharge_point}】给${user.server_name}的【${user.role_name}】吗`
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          id: item.id,
          name: item.recharge_point,
          userId: user.user_id,
          serverId: user.server_code,
          serverName: user.server_name,
          roleId: user.role_code,
          roleName: user.role_name
        }
        supportSubmit(param).then(res => {
          if (res.data.success) {
            this.$message.success("扶持发放成功")
          } else {
            this.$message.error(res.data.error.message);
          }
        })
      }).catch(() => {
      })
    },
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then(res => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          this.showSend = menuCodes.includes("support_send");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    loadData(index) {
      this.currentIndex = index;
      this.loading = true;
      let params = {
        pageNo: index,
        pageSize: 15,
        params: {
          game_id: this.queryField.gameId,
          game_name: this.queryField.gameName,
          server_code: this.queryField.serverCode,
          server_name: this.queryField.serverName,
          role_code: this.queryField.roleCode,
          role_name: this.queryField.roleName,
          user_id: this.queryField.userId,
          user_name: this.queryField.userName,
        }
      }
      getSupportRoleList(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      })
    },
  }

}
</script>
<style lang="scss" scoped>
  .cps-main-page {
    .cps-table-data {
      td {
        .el-image {
          display: inherit;
        }
      }
    }

    /deep/.drawer-table-data {
      padding: 0 10px;
      thead {
        color: #2b2929;
        tr{
          th{
            background-color: #f5f5f5;
          }
        }
      }

      td {
        font-weight: 500;
        .cell{
          button{
            padding: 0;
          }
        }
      }
      .el-table__cell{
        padding: 8px 0;
      }

    }

  }
</style>

